export const useThirdSlide = (props) => {
    // Destructured props
    const {} = props

    return {

    }
}
